/**
 * Raha käsitellään aina kokonaislukuina sentteinä. Liukulukuja ei käytetä summiin.
 */
export type Cents = number;

/** "1 234,50", "1234.5", "12" → senteiksi. Palauttaa null, jos syöte ei ole kelvollinen summa. */
export function parseEuroToCents(input: string): Cents | null {
  const cleaned = input.replace(/[\s €]/g, '').replace(',', '.');
  if (!/^-?\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const negative = cleaned.startsWith('-');
  const [whole = '0', fraction = ''] = cleaned.replace('-', '').split('.');
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  if (!Number.isSafeInteger(cents)) return null;
  return negative ? -cents : cents;
}

const formatters = new Map<string, Intl.NumberFormat>();

/** 123456 → "1 234,56 €" (suomeksi). */
export function formatCents(cents: Cents, locale = 'fi-FI'): string {
  let formatter = formatters.get(locale);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' });
    formatters.set(locale, formatter);
  }
  return formatter.format(cents / 100);
}

/** Jakaa summan omistusosuudella (peruspisteet, 10000 = 100 %). Pyöristys lähimpään senttiin. */
export function shareOfCents(cents: Cents, ownershipBp: number): Cents {
  return Math.round((cents * ownershipBp) / 10000);
}
